import { Observable } from "rxjs";
import { IUserLoginRequest, IUserLoginResponse, IForgotPasswordRequest, IResetPasswordRequest, IResetPasswordResponse, IUser } from "../../../interfaces/user/interface-user";

export abstract class AuthGateway {
    abstract Login(user: IUserLoginRequest, loginUrlForBrand: string): Observable<IUserLoginResponse>;
    abstract GetIPAddress(): any
    abstract GetUserLogin(): Observable<IUser>;
    abstract SaveUserLogin(User: IUser): void;
    abstract Logout(): void;
    abstract refreshToken(): void;
    abstract forgotPassword(forgotPassword: IForgotPasswordRequest): Observable<IResetPasswordResponse>;
    abstract validatePasswordResetToken(resetPassword: IResetPasswordRequest): Observable<IResetPasswordResponse>;
    abstract resetPassword(resetPassword: IResetPasswordRequest): Observable<IResetPasswordResponse>;
    abstract getLastActivity(): string;
    abstract setLastActivity(): void;
    abstract validateDownTime(): void;
    abstract startRefreshTokenTimer(): void;
    abstract ShowToolTips(): void;
}